import { TThunkAction } from '../../types/redux';
import { setConstructionProgressLoading, setConstructionProgressNextPage } from './actions';
import { getConstructionProgress } from '../../services/constructionProgress';
import { selectNewbuildingId } from '../../selectors/newbuilding';
import { selectConstructionProgressPage } from '../../selectors/constructionProgress';

export function fetchConstructionProgress(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();
    const newbuildingId = selectNewbuildingId(state);
    const page = selectConstructionProgressPage(state);
    const nextPage = page + 1;

    dispatch(setConstructionProgressLoading(true));

    try {
      const { constructionProgress, isLast } = await getConstructionProgress(httpApi, {
        newbuildingId,
        page: nextPage,
      });

      dispatch(setConstructionProgressNextPage({ constructionProgress, isLast, nextPage }));
    } catch (error) {
      logger.error(error);

      dispatch(setConstructionProgressLoading(false));
    }
  };
}
